<template>
  <g>
    <g clip-path="url(#clip0_15_302)">
      <path
        d="M16.5 9.00019C16.08 9.00019 15.67 9.04018 15.26 9.11018L2.4 3.60018C1.74 3.31018 1.01 3.80019 1.01 4.51019L1 9.20018C1 9.67018 1.33 10.0802 1.78 10.1802L10 12.0002L1.78 13.8302C1.33 13.9302 1 14.3302 1 14.8002L1.01 19.4802C1.01 20.2002 1.74 20.6802 2.4 20.4002L9.08 17.5402C9.59 21.1902 12.71 24.0002 16.5 24.0002C20.64 24.0002 24 20.6402 24 16.5002C24 12.3602 20.64 9.00019 16.5 9.00019ZM16.5 22.0002C13.47 22.0002 11 19.5302 11 16.5002C11 13.4702 13.47 11.0002 16.5 11.0002C19.53 11.0002 22 13.4702 22 16.5002C22 19.5302 19.53 22.0002 16.5 22.0002Z"
      />
      <path
        d="M18.62 14.3802C18.42 14.1802 18.11 14.1802 17.91 14.3802L16.5 15.7902L15.09 14.3802C14.89 14.1802 14.58 14.1802 14.38 14.3802C14.18 14.5802 14.18 14.8902 14.38 15.0902L15.79 16.5002L14.38 17.9102C14.18 18.1102 14.18 18.4202 14.38 18.6202C14.58 18.8202 14.89 18.8202 15.09 18.6202L16.5 17.2102L17.91 18.6202C18.11 18.8202 18.42 18.8202 18.62 18.6202C18.82 18.4202 18.82 18.1102 18.62 17.9102L17.21 16.5002L18.62 15.0902C18.82 14.8902 18.82 14.5702 18.62 14.3802Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_302">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
